module.exports = __webpack_public_path__ + "static/img/bord_majesteit_3.e72fbe4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bord_majesteit_3.jpg
// module id = vYFU
// module chunks = 0